import { defaultGreyLight, defaultOrange } from '../../../../app/globalStyle';

export const getBackgroudColor = (tipo, tipoIndicadorFup48) => {
  if (tipo === tipoIndicadorFup48) {
    return defaultOrange;
  }

  return defaultGreyLight;
};
